import { ExternalLink, Play } from "lucide-react";

const toEmbed = (url) => {
  // Convert https://www.loom.com/share/ID to https://www.loom.com/embed/ID
  try {
    const m = url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/);
    if (m) return `https://www.loom.com/embed/${m[1]}`;
  } catch {
    /* noop */
  }
  return url;
};

export const LoomEmbed = ({ url, title }) => {
  if (!url) return null;
  const embed = toEmbed(url);
  return (
    <div
      className="brut-border brut-shadow bg-background overflow-hidden"
      data-testid="loom-embed-wrapper"
    >
      {/* Faux browser bar */}
      <div className="flex items-center justify-between border-b-2 border-foreground bg-muted px-3 py-2">
        <div className="flex items-center gap-1.5">
          <span className="w-3 h-3 rounded-full bg-[#FF5F57] border border-foreground" />
          <span className="w-3 h-3 rounded-full bg-[#FEBC2E] border border-foreground" />
          <span className="w-3 h-3 rounded-full bg-[#28C840] border border-foreground" />
        </div>
        <div className="flex-1 mx-3 truncate">
          <span className="font-mono text-[11px] text-muted-foreground truncate flex items-center gap-1.5">
            <Play className="w-3 h-3" strokeWidth={3} />
            loom.com — video walkthrough
          </span>
        </div>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          data-testid="loom-open-external"
          className="text-[11px] font-mono inline-flex items-center gap-1 hover:underline"
        >
          open <ExternalLink className="w-3 h-3" strokeWidth={2.5} />
        </a>
      </div>
      <div className="aspect-video bg-muted">
        <iframe
          src={embed}
          title={title || "Loom walkthrough"}
          frameBorder="0"
          allowFullScreen
          className="w-full h-full"
        />
      </div>
    </div>
  );
};
